<template>
    <el-drawer
        :title="formData.id ? '管理优惠券' : '创建优惠券'"
        :visible.sync="visible"
        :wrapperClosable="false"
        :size="480"
        @closed="closed"
    >
        <div class="drawer-content">
            <el-form :model="formData" :rules="rules" ref="formData" label-position="top" >
                <el-form-item prop="name" label="名称:">
                    <el-input v-model="formData.name" placeholder="请填写" size="medium" :maxlength="20"></el-input>
                </el-form-item>
                <el-form-item prop="time" label="有效期:">
                    <el-date-picker
                        v-model="formData.time"
                        type="datetimerange"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        class="fl"
                        size="small"
                        :default-time="['00:00:00', '23:59:59']"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        unlink-panels
                        >
                    </el-date-picker>
                </el-form-item>
                <el-form-item prop="couponPrice" label="优惠金额(元):">
                    <el-input v-model="formData.couponPrice" placeholder="请填写" size="medium" :maxlength="12"></el-input>
                </el-form-item>
                <el-form-item prop="couponSubtractPrice" label="满减金额(元):">
                    <el-input v-model="formData.couponSubtractPrice" placeholder="请填写" size="medium" :maxlength="12"></el-input>
                    <small class="from-tip"><span class="el-icon-warning"></span>订单总金额达到满减金额后才可使用，<em class="color-danger">满减金额必须大于优惠金额至少2.00元</em></small>
                </el-form-item>
                <el-form-item prop="limitIds" label="商品限制:">
                    <el-input type="textarea" v-model="formData.limitIds" placeholder="请填写" size="medium" :maxlength="200"></el-input>
                    <small class="from-tip"><span class="el-icon-warning"></span>填写商品ID，多个ID之间用逗号分隔</small>
                </el-form-item>
                <el-form-item prop="type" label="补贴承担:">
                    <el-radio v-model="formData.type" :label="0">秀动平台</el-radio>
                    <el-radio v-model="formData.type" :label="1">秀动商家(B类用户)</el-radio>
                </el-form-item>
                <el-form-item v-if="formData.type === 1" prop="subsidyUser" label="秀动商家(B类用户):">
                    <el-select 
                        v-model="formData.subsidyUser" 
                        :filterable="true" 
                        :remote="true" 
                        :remote-method="remote" 
                        :loading="remoteLoading"
                        placeholder="选择承担补贴的商家" 
                        size="medium">
                        <el-option v-for="item in remoteOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="visible = false">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="submitLoading">提交</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
export default {
    data() {
        this.defaultFormData = {
            id: null,
            // 名称：必填，最多20个字符，如果为空，提示：【请填写名称】，如果超长，提示：【名称最多允许填写20个字符】
            name: null,
            // 有效期：必填，使用日期时间范围选择器
            time: null,
            // 优惠金额：必填，取值范围【0.00，99999999.99】，如果为空，提示：【请填写优惠金额】，如果格式错误，提示：【请填写合理的优惠金额】
            couponPrice: null,
            couponSubtractPrice: null,
            // 商品限制：选填，最多200个字符，仅允许填写数字或逗号，如果格式有误，提示：【请填写有效的商品ID】，
            // 如果超长，提示：【商品限制最多允许填写200个字符】，下面的提示文案如图所示：【填写商品ID，多个ID之间用逗号分隔】，
            // 注意：如果用户填写的是中文逗号，需要自动替换成英文逗号
            limitIds: null,
            // 补贴承担：必填，单选
            // 秀动平台：表示该优惠券的成本由秀动承担，默认选中该项
            // 秀动商家（B类用户）：表示该优惠券的成本由B类用户承担
            // 选择了【秀动商家（B类用户）】后，后面出现输入框，要求指定承担的B类用户，且为必填，输入框默认文案：【填写承担补贴的商家】，
            // 如果为空，提示：【请填写承担补贴的商家用户】，建议使用带有输入建议的输入框，根据关键字联想出B类用户的名称，
            // 同时注意，需要在名称前显示B类用户的身份（艺人、场地、厂牌），格式如图所示
            type: 0, 
            // 补贴方ID,0为秀动平台，其他为B类用户ID
            subsidyUser: null
        }

        this.userTypeM = {1: '乐迷', 2: '艺人', 3: '场地', 5: '厂牌'};
        const priceRx = /(?:^[1-9]([0-9]+)?(?:\.[0-9]{1,2})?$)|(?:^(?:0)$)|(?:^[0-9]\.[0-9](?:[0-9])?$)/;
        // 验证优惠金额
        const validateCouponPrice = (rule, value, callback) => {
            if (!priceRx.test(value)) {
                callback(new Error('请填写合理的优惠金额'));
            } else {
                callback();
            }
        };

        // 验证满减金额
        const validateCouponSubtractPrice = (rule, value, callback) => {
            if (!priceRx.test(value)) {
                callback(new Error('请填写合理的满减金额'));
            } else {
                callback();
            }
        };

        // 验证使用范围
        const validateLimitIds = (rule, value, callback) => {
            if (value && !/^[,，0-9]+$/.test(value)) {
                callback(new Error('请填写有效的商品ID'));
            } else {
                callback();
            }
        };
        
        return {
            visible: false,
            formData: {
                ...this.defaultFormData
            },
            rules: {
                name: { required: true, message: "请填写名称", trigger: 'change'},
                time: { required: true, message: "请选择有效期", trigger: 'change'},
                couponPrice: [
                    { required: true, message: "请填写优惠金额", trigger: 'change'},
                    { validator: validateCouponPrice, trigger: 'change'}
                ],
                couponSubtractPrice: [
                    { required: true, message: "请填写满减金额", trigger: 'change'},
                    {validator: validateCouponSubtractPrice, trigger: 'change'}
                ],
                limitIds: {validator: validateLimitIds, trigger: 'change'},
                type: { required: true, message: "请选择补贴承担", trigger: 'change'},
                subsidyUser: { required: true, message: "请选择承担补贴的商家用户", trigger: 'change'}
            },
            submitLoading: false,
            remoteLoading: false,
            remoteOptions: []
        };
    },
    methods: {
        show(data) {
            const {id = null, name = null, beginTime, endTime, couponPrice = null, couponSubtractPrice = null, limitIds = null, subsidyUser = 0, subsidyUserType, subsidyUserName} = data || {};
            const time = beginTime && endTime ? [beginTime, endTime] : null;
            const type = subsidyUser ? 1 : 0;

            if(subsidyUser) {
                this.remoteOptions = [{label: `${this.userTypeM[subsidyUserType]} - ${subsidyUserName}`, value: subsidyUser}];
            }

            this.formData = {id, name, time, couponPrice, couponSubtractPrice, limitIds, type, subsidyUser: subsidyUser ? subsidyUser : null};
            this.visible = true;
        },
        closed() {
            this.formData = {...this.defaultFormData};
            this.remoteOptions = [];
            
            this.$nextTick(() => {
                this.$refs['formData'].clearValidate();
            });
        },
        async remote(q) {
            if (!q) {
                this.remoteOptions = [];
                return;
            }

            this.remoteLoading = true;

            const res = await this.$request({
                url: '/userInfo/query',
                method: 'post',
                data: {queryCount: 20, queryValue: q, userType: -1}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.remoteLoading = false;
            });

            const { state, msg , result } = res.data;

            if(state !== '1') {
                this.$message.error(msg || '请求失败');
                return ;
            }

            this.remoteOptions = (result || []).map(item => {
                const {userType, id, name} = item;
                return {label: `${this.userTypeM[userType]} - ${name}`, value: id};
            });
        },
        // 表单提交
        submitForm() {
            this.$refs["formData"].validate((valid) => {
                if(!valid) {
                    return ;
                }

                const {formData: {id, time, couponPrice, couponSubtractPrice, limitIds, type, subsidyUser, ...otherData}} = this;

                if(parseFloat(couponPrice) > 99999999.99) {
                    return this.$message.error('优惠金额取值范围【0.00，99999999.99】');
                }

                if(parseFloat(couponSubtractPrice) > 99999999.99) {
                    return this.$message.error('优惠金额取值范围【0.00，99999999.99】');
                }

                if(parseFloat(couponSubtractPrice) - parseFloat(couponPrice) < 2) {
                    return this.$message.error('请填写合理的满减金额');
                }
                
                const [beginTime, endTime] = time || [];

                const formData = {
                    id, 
                    beginTime, 
                    endTime, 
                    couponPrice, 
                    couponSubtractPrice,
                    limitIds: limitIds ? limitIds.replace(/，/g, ',') : null,
                    subsidyUser: type ? subsidyUser : 0,
                    ...otherData
                }

                this.saveCoupon(formData);
            });
        },
        // 验证优惠券是否存在已经被用户领取
        async validateCoupon(formData) {
            const {id} = formData;
            
            this.submitLoading = true;

            const res = await this.$request({
                url: '/coupon/goods/validate',
                method: 'post',
                params: {id}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.submitLoading = false;
            });

            const { state, msg, result } = res.data;

            if(state !== '1') {
                this.$message.error(msg || '请求失败');
                return ;
            }
            
            if(result.unUseCount <= 0) {
                this.saveCoupon(formData);
                return ;
            }

            // 二次确认
            this.$emit('confirm', {...formData});
            this.visible = false;
        },
        // 保存
        async saveCoupon(formData) {
            this.submitLoading = true;

            const res = await this.$request({
                url: '/coupon/goods/save',
                method: 'post',
                data: {...formData}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.submitLoading = false;
            });

            const { state, msg } = res.data;

            if(state !== '1') {
                this.$message.error(msg || '请求失败');
                return ;
            }

            this.$emit('submitSuccess');
            this.visible = false;
        }
    }
};
</script>